import { Stack, SxProps, Typography } from '@mui/material';
import { CopyButton, TokenFormat, TokenFormatProps } from 'shared';
import { formatUnits } from 'viem';

interface PaymentTokenAmountProps extends Omit<TokenFormatProps, 'amount' | 'decimals' | 'sx'> {
  tokenSymbol: string;
  networkName: string;
  amount: string | bigint;
  decimals: number;
  withCopy?: boolean;
  sx?: SxProps;
}

export const PaymentTokenAmount = ({
  tokenSymbol,
  networkName,
  amount,
  decimals,
  maxTotalLength = 14,
  withCopy = true,
  sx,
  ...rest
}: PaymentTokenAmountProps) => {
  return (
    <Stack alignItems="center" sx={sx}>
      <Typography variant="h5" textTransform="uppercase" className="primary" mb={0.25}>
        {`${tokenSymbol} (${networkName})`}
      </Typography>
      <Stack direction="row" gap={1}>
        <TokenFormat
          amount={amount}
          maxTotalLength={maxTotalLength}
          maxDecimalDigits={decimals}
          decimals={decimals}
          symbol={tokenSymbol}
          approx
          variant="h5"
          className="primary"
          {...rest}
        />
        {withCopy && <CopyButton successText="Amount coppied" text={formatUnits(BigInt(amount), decimals)} />}
      </Stack>
    </Stack>
  );
};
